import $ from 'jquery';
import anim from 'core/loading-animation';
import ReviewsTable from 'components/reviews-table';
import formatting from 'core/formatting';
import filterBox from 'components/filter-box';
import keyMetrics from 'components/metrics';
import browser_storage from 'core/browser-storage';
import automationBanner from 'components/automation-banner';
import urls from 'core/urls';
import selectize_util from "root/static/js/components/selectize";

let nodes = {
    metrics: {
        main: document.querySelector(".key-figures"),
        wrap: document.querySelector(".metrics-wrap"),
        metricsContainer: document.querySelector(".metrics-wrap .metrics"),
        cards: document.querySelectorAll(".metrics-wrap .metrics .card"),
        header: document.querySelector(".key-figures header"),
        benchmarksToggle: document.querySelector("#toggleBenchmarks"),
    }
}

let metrics = keyMetrics.init(nodes.metrics, "reviews");
metrics.initBenchmarks();

window.addEventListener("resize", metrics.adjustMetricsHeight);

automationBanner();
class Reviews {
    constructor () {

        filterBox.create(
            'csat-reviews', // page prefix
            urls['csat:review-filters'](), // filter data endpoint
            (data) => { // on change
                if(this.table) this.table.update(data)
            },
            (data) => {
                console.log("on ready data", data)
                this.populateDialogOptions(data)
            }
        );
        
        this.table = new ReviewsTable(
            '#reactions', 
            anim,
            this.updateEvent.bind(this)
        );
    }

    initMetrics() {
        let metrics = Object();
        metrics['response_rate'] = 0;
        metrics['net_csat_score'] = 0;
        metrics['total'] = 0;
        metrics['positive'] = 0;
        metrics['negative'] = 0;
        metrics['neutral'] = 0;
        metrics['net_csat_score_all'] = 0;
        metrics['answered'] = 0;
        return metrics;
    }

    updateEvent(data) {
        if('metrics' in data) {
            this.updateMetrics(data.metrics, data.benchmarks);
            metrics.adjustMetricsHeight();
        }

        setTimeout(() => {
            this.table.resizeHandler();
        }, 1);
    }

    updateMetrics(metrics, benchmarks) {
        if(!metrics){
            metrics = this.initMetrics();
        }
        $('#kf-net-csat-score-current-mini').text(formatting.asNetCsatScore(metrics.net_csat_score));
        $('#kf-response-rate-mini').text(formatting.asResponseRate(metrics.response_rate));
        $('#kf-sum-current-mini').text(formatting.asReviewCount(metrics.answered));

        $('#kf-positive-current-mini').text(formatting.asReviewCount(metrics.positive));
        $('#kf-neutral-current-mini').text(formatting.asReviewCount(metrics.neutral));
        $('#kf-negative-current-mini').text(formatting.asReviewCount(metrics.negative));

        $('#kf-response-rate').html(`${formatting.asResponseRate(metrics.response_rate)}<div class="symbol">%</div>`);
        $('#kf-response-rate-answered').text(formatting.asReviewCount(metrics.answered));
        $('#kf-response-rate-total').text(formatting.asReviewCount(metrics.total));
        $('#kf-net-csat-score-current').text(formatting.asNetCsatScore(metrics.net_csat_score));
        $('#kf-sum-current').text(formatting.asReviewCount(metrics.answered));

        $('#kf-positive-current-ratio').text(formatting.asPercentage(formatting.cleanPercentageFraction(metrics.positive, metrics.answered)));
        $('#kf-positive-current').text(formatting.asReviewCount(metrics.positive));

        $('#kf-neutral-current-ratio').text(formatting.asPercentage(formatting.cleanPercentageFraction(metrics.neutral, metrics.answered)));
        $('#kf-neutral-current').text(formatting.asReviewCount(metrics.neutral));

        $('#kf-negative-current-ratio').text(formatting.asPercentage(formatting.cleanPercentageFraction(metrics.negative, metrics.answered)));
        $('#kf-negative-current').text(formatting.asReviewCount(metrics.negative));

        // benchmarks 
        if(benchmarks) {
            let scoreBenchmarks = document.querySelector(".card.main-score .benchmarking");
            let responseRateBenchmarks = document.querySelector(".card.response-rate .benchmarking");

            let applyBenchmarks = (benchmarkWrapper, type) => {
                let mainScoreBenchmark = benchmarks[`${type}_median`];
                let topTenBenchmark = benchmarks[`top_${type}_median`];

                 // benchmark elements
                let allCompaniesElement = benchmarkWrapper.querySelector(".bm-score.all");
                let topTenElement = benchmarkWrapper.querySelector(".bm-score.top10");
                let mainDeltaElement = benchmarkWrapper.querySelector(".diff.all");
                let topDeltaElement = benchmarkWrapper.querySelector(".diff.top10");

                mainDeltaElement.classList.remove("negative", "positive");
                topDeltaElement.classList.remove("negative", "positive");
                allCompaniesElement.innerHTML = "N/A";
                topTenElement.innerHTML = "-";
                mainDeltaElement.innerHTML = "N/A";
                topDeltaElement.innerHTML = "N/A";

                if(mainScoreBenchmark) {
                    let percentSign = type === "response_rate" ? "%" : "";
                    benchmarkWrapper.querySelector(".bm-score.all").innerText = mainScoreBenchmark.toFixed(1) + percentSign;

                    if(topTenBenchmark) {
                        benchmarkWrapper.querySelector(".bm-score.top10").innerText = topTenBenchmark.toFixed(1) + percentSign;
                    }

                    let customerScore = type === "score" ? metrics.net_csat_score : metrics.response_rate; 
                    
                    let renderDeltas = (element, benchmarkScore) => {
                        let delta = customerScore - benchmarkScore;
                        let symbol = "";

                        if(delta === 0) delta = 0;

                        if(delta < 0) {
                            element.classList.add("negative");
                            symbol = "-";
                        }

                        if (delta > 0) {
                            element.classList.add("positive");
                            symbol = "+";
                        }

                        element.innerHTML = `<div class="symbol">${symbol}</div>${(Math.abs(delta)).toFixed(1)}`;
                    }

                    // apply delta values for All Companies
                    renderDeltas(mainDeltaElement, mainScoreBenchmark);

                    if(topTenBenchmark) {
                        // apply delta values for Top 10%
                        renderDeltas(topDeltaElement, topTenBenchmark);
                    }
                }
            }
            
            // apply benchmarks to CSAT Main Score
            applyBenchmarks(scoreBenchmarks, "score");
            // apply benchmarks to CSAT Response Rate
            applyBenchmarks(responseRateBenchmarks, "response_rate");
        } else {
            // no data - render deltas as 0
            let deltas = document.querySelectorAll(".card .benchmarking .diff");
            deltas.forEach(delta => {
                delta.classList.remove("negative", "positive");
                delta.innerHTML = "0.0";
            })
        }
    }

    populateDialogOptions(data) {
        let reactionDetailsTagsWidget = selectize_util.optionalInstance($('#reaction-details-tags'));
        let reactionDetailsAgentsWidget = selectize_util.optionalInstance($('#reactions-details-agents-edit'));

        data.tags.forEach(tag => {
            if(!reactionDetailsTagsWidget.options[tag]) {
                reactionDetailsTagsWidget.addOption({value: tag, text: tag});
            }
        })

        data.agents.forEach(agent => {
            if(!reactionDetailsAgentsWidget.options[agent]) {
                reactionDetailsAgentsWidget.addOption({value: agent, text: agent});
            }
        })        
    }
}

export default new Reviews();
